import {defineStore} from 'pinia'

export interface UserSession {
    type: 'ITLM' | 'Facebook' | 'Google';
    accessToken: string;
    email: string;
    firstName: string;
    lastName: string;
    exp: number;
}

export const useAuthStore = defineStore('auth', () => {
    let localStoreName = `itlm-v1-user-session`;

    const user = ref<UserSession>();

    const loadValue = () => {
        if (import.meta.client) {
            const saved = localStorage.getItem(localStoreName);
            if (saved) {
                try {
                    user.value = JSON.parse(saved);
                } catch (error) {
                    console.error("Failed to parse user", error);
                }
            }
        }
    }

    const isLoggedIn = computed(() => {
        if (!user.value) {
            loadValue();
        }

        if (user.value) {
            const loggedIn = user.value.exp > Date.now();
            if (!loggedIn) {
                clearSessionData();
            }
            return loggedIn;
        }
        return false;
    });

    const clearSessionData = () => {
        user.value = undefined;
        localStorage.removeItem(localStoreName);
    }

    // Action: Set session
    const login = (data: UserSession) => {
        localStorage.setItem(localStoreName, JSON.stringify(data));
        user.value = data;
    };

    // Action: Clear session
    const logout = () => {
        clearSessionData();
        const localePath = useLocalePath();
        navigateTo(localePath('/sign-in'));
    };

    return {user, isLoggedIn, login, logout};
});